import { Platform } from "react-native"

export function shouldAllowLogIn() {
  if (Platform.OS !== "web") {
    return true
  }
  // We dont want right now to allow everyone to log in from web
  // return process.env.ENVIRONMENT !== "production"
  return false
}

export function shouldAllowWebPaymentRequest() {
  if (Platform.OS !== "web") {
    return true
  }

  return true
}
